import React from 'react';
// import './account-verification.css';
import '../Auth/Registration/Verification/account-verification.css'
import { Link } from 'react-router-dom';
import { Nav, NavLink } from 'react-bootstrap';

const PasswordResetVerificationPage = () => {
    return (
        <>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-7 mx-auto av-wrap-vh-center'>
                        <div className='av-wrap '>
                            <div><img className='img-review' src='images/review-img.png' alt='Review' /></div>
                            <div className='av-wrap-text mt-3'> A password reset link has been sent to your registered email address.Please check your email and click on the link to reset your password.</div>
                            <div style={{ display: 'flex', gap: '30px' }}>
                                <Link to={'/'}>
                                    <button className='btn btn-signup btn btn-primary py-2 mt-3'>
                                        Home Page
                                    </button>
                                </Link>
                                <a href="https://www.gmail.com" rel="noopener noreferrer">
                                    <button className='btn btn-signup btn btn-primary py-2 mt-3'>
                                        Go to Gmail
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordResetVerificationPage;
